export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayISO() {
  return toISO(new Date());
}

export function parseISO(s) {
  return new Date(s + "T00:00:00");
}

export function fmtDateLong(iso) {
  try {
    return parseISO(iso).toLocaleDateString(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtDateShort(iso) {
  try {
    return parseISO(iso).toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtMonthYear(d) {
  return d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

export function fmtTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
}

// 6 by 7 grid of days for the month containing `anchor`, Monday first.
export function monthMatrix(anchor) {
  const y = anchor.getFullYear();
  const m = anchor.getMonth();
  const first = new Date(y, m, 1);
  const offset = (first.getDay() + 6) % 7; // Monday = 0
  const gridStart = new Date(y, m, 1 - offset);
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  // Only as many full weeks as needed to include the last day of the month,
  // so a trailing week that is entirely next month is not drawn.
  const total = Math.ceil((offset + daysInMonth) / 7) * 7;
  const today = todayISO();
  const cells = [];
  for (let i = 0; i < total; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    const iso = toISO(d);
    cells.push({ iso, day: d.getDate(), inMonth: d.getMonth() === m, isToday: iso === today });
  }
  return cells;
}

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// Posting cadence options. Values match the backend.
export const FREQUENCIES = [
  { value: "daily", label: "Every day" },
  { value: "every_2_days", label: "Every 2 days" },
  { value: "every_3_days", label: "Every 3 days" },
  { value: "twice_weekly", label: "Twice a week" },
  { value: "weekly", label: "Weekly" },
];

const FREQUENCY_GAPS = {
  daily: [1],
  every_2_days: [2],
  every_3_days: [3],
  twice_weekly: [3, 4],
  weekly: [7],
};

export const MAX_POSTS_PER_PLATFORM = 8;

export function addDays(d, n) {
  const out = new Date(d);
  out.setDate(out.getDate() + n);
  return out;
}

// How many posts per platform a date range and cadence will produce. Mirrors
// build_schedule on the backend (for platform index 0) so the UI can preview
// the count before generating.
export function scheduleCount(startISO, endISO, frequency, cap = MAX_POSTS_PER_PLATFORM) {
  const start = startISO ? parseISO(startISO) : new Date();
  let end = endISO ? parseISO(endISO) : addDays(start, 27);
  if (end < start) end = start;
  const gaps = FREQUENCY_GAPS[frequency] || [7];
  let cur = new Date(start);
  let count = 0;
  let gi = 0;
  while (cur <= end && count < cap) {
    count += 1;
    cur = addDays(cur, gaps[gi % gaps.length]);
    gi += 1;
  }
  return Math.max(1, count);
}

export function frequencyLabel(value) {
  return (FREQUENCIES.find((f) => f.value === value) || {}).label || "Weekly";
}

// Stable fake engagement numbers for the preview cards (visual only).
function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function pseudoCount(id, salt, min, max) {
  const h = hashString(String(id) + salt);
  return min + (h % (max - min + 1));
}

export function fmtCount(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
}